import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { UploadIcon } from "../Icon";
import { useDropzone } from "react-dropzone";
import { useController } from "react-hook-form";
import StyledFormControl from "./StyledFormControl";

const StyledUploadInput = ({ name, control, onDrop }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "image/png": [], "image/jpeg": [] },
    multiple: false,
  });
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: { required: "Upload at least one plan for the First Floor." },
  });

  return (
    <StyledFormControl
      label={"Floors"}
      id={name}
      error={!!error}
      helperText={error?.root?.message}
      showLabel={true}
    >
      <Box
        {...getRootProps()}
        sx={(theme) => ({
          border: `2px dashed ${error ? theme.palette.error.main : "#ccc"}`,
          padding: 3,
          textAlign: "center",
          borderRadius: 2,
          // my: 2,
          cursor: "pointer",
          bgcolor: isDragActive ? "#f0f0f0" : "inherit",
        })}
        aria-description={`${name}-helper-text`}
      >
        <input {...getInputProps()} />
        <input {...field} type="hidden" />
        <Stack
          direction={"row"}
          gap={1}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <UploadIcon sx={{ fontSize: 15 }} />

          <Typography>
            Drag & Drop or{" "}
            <Typography
              component={"span"}
              sx={{
                textDecoration: "underline",
                fontWeight: 500,
                textUnderlineOffset: 5,
              }}
            >
              Choose Floor Plan
            </Typography>{" "}
            image to add floor
          </Typography>
        </Stack>
        <Typography variant="body2" color="textSecondary">
          Only JPEG and PNG are supported.
        </Typography>
      </Box>
    </StyledFormControl>
  );
};

export default React.memo(StyledUploadInput);
